export default{
    state:{ 
        versionapp:'v2.7.1'
    },
    getters:{
        getVersionApp(state){
            return state.versionapp
        }
    }
}